import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PopoverSurfaceListDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getOptionRowMinHeight
} from "../../../optionRow/stylesheet";

export const POPOVER_SURFACE_LIST_MAX_ROWS = 8;

const stylesheet = StyleSheet.create({
    content: {
        flexDirection: "column"
    },
    list: {
        flexShrink: 1,
        flexGrow: 0
    }
});

export const useStyles = ({
    controlHeights,
    touchTargets,
    pointerType,
    maxRows
}: PopoverSurfaceListDynamicStyleType) => {
    const styles = {
        list: {
            maxHeight: getOptionRowMinHeight({
                variant: "popover",
                controlHeights,
                touchTargets,
                pointerType
            }) * maxRows
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
